import { EMPTY, merge } from "rxjs";
import { isEmpty, mergeMap, publish } from "rxjs/operators";
export function concatIfEmpty(observable) {
    return (source) => source.pipe(publish((sharedSource) => merge(sharedSource, sharedSource.pipe(isEmpty(), mergeMap((empty) => (empty ? observable : EMPTY))))));
}
//# sourceMappingURL=concatIfEmpty.js.map